import { BaseSyntheticEvent, ReactNode } from 'react';
import { DrawerLoader } from '@/components/ui/drawer-loader';
import { DrawerContentLayout } from './drawer-content-layout';

export type DrawerContentFormLayoutProps = {
  buttonItems: ReactNode[];
  fieldItems: ReactNode[];
  loading?: boolean;
  onSubmit: (e?: BaseSyntheticEvent) => Promise<void>;
};

export const DrawerContentFormLayout = ({
  buttonItems,
  fieldItems,
  loading,
  onSubmit,
}: DrawerContentFormLayoutProps) => (
  <>
    <form autoComplete="off" className="h-full" onSubmit={onSubmit}>
      <DrawerContentLayout
        buttonItems={buttonItems}
        mainContent={<div className="flex flex-col gap-4">{fieldItems}</div>}
      />
    </form>
    {loading && <DrawerLoader />}
  </>
);
